import api from '@pray/shared/utils/api';

export async function unschedulePrayTvContent({ artistId, contentId, slotId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!slotId) throw Error('Slot ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/pray-tv-schedule/${slotId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
